import React from "react";
import { Label, Icon } from "semantic-ui-react";

const styles = {
	mainContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: "4px",
		width: "100%",
	},
	title: {
		color: "#00917d",
		fontWeight: 600,
		textTransform: "uppercase",
		fontSize: "0.9em",
	},
	content: {
		paddingTop: 20,
	},
};

const AdminDataContainer = ({ title, onEdit, children, ribbonColor, ribbonLabel, style, icon, ...props }) => {
	return (
		<div style={{ ...styles.mainContainer, style }}>
			<Label as="span" color={ribbonColor} ribbon>
				{icon && <Icon name={icon} />}
				{ribbonLabel}
			</Label>

			<div style={styles.content}>{children}</div>
		</div>
	);
};

export default AdminDataContainer;
